/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SsoAdminPortalButtonQueryVariables = {
    orgRelayId: string;
    billingGroupId: string;
};
export type SsoAdminPortalButtonQueryResponse = {
    readonly org: {
        readonly id?: string | undefined;
        readonly billingGroupForId?: {
            readonly " $fragmentRefs": FragmentRefs<"SsoAdminPortalButton_billingGroup">;
        } | undefined;
        readonly " $fragmentRefs": FragmentRefs<"SsoAdminPortalButton_org">;
    } | null;
};
export type SsoAdminPortalButtonQuery = {
    readonly response: SsoAdminPortalButtonQueryResponse;
    readonly variables: SsoAdminPortalButtonQueryVariables;
};



/*
query SsoAdminPortalButtonQuery(
  $orgRelayId: ID!
  $billingGroupId: String!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      id
      ...SsoAdminPortalButton_org
      billingGroupForId(billingGroupId: $billingGroupId) {
        __typename
        ...SsoAdminPortalButton_billingGroup
      }
    }
    id
  }
}

fragment SsoAdminPortalButton_billingGroup on BillingGroupErrorable {
  __isBillingGroupErrorable: __typename
  ... on BillingGroup {
    id
    type
    ssoAdminPortalLink {
      __typename
      ... on SsoAdminPortalLink {
        link
      }
      ... on GraphEntityError {
        message
        statusCode
      }
    }
  }
  ... on GraphEntityError {
    message
    statusCode
  }
}

fragment SsoAdminPortalButton_org on Org {
  id
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "billingGroupId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v4 = [
        {
            "kind": "Variable",
            "name": "billingGroupId",
            "variableName": "billingGroupId"
        } as any
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "SsoAdminPortalButtonQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "billingGroupForId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "SsoAdminPortalButton_billingGroup"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "SsoAdminPortalButton_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "SsoAdminPortalButtonQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "billingGroupForId",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isBillingGroupErrorable"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v3 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "type",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "ssoAdminPortalLink",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "link",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "SsoAdminPortalLink",
                                                            "abstractKey": null
                                                        },
                                                        (v6 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "BillingGroup",
                                            "abstractKey": null
                                        },
                                        (v6 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "da61c060124e787763fedcd502b6a0f0",
            "id": null,
            "metadata": {},
            "name": "SsoAdminPortalButtonQuery",
            "operationKind": "query",
            "text": "query SsoAdminPortalButtonQuery(\n  $orgRelayId: ID!\n  $billingGroupId: String!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      id\n      ...SsoAdminPortalButton_org\n      billingGroupForId(billingGroupId: $billingGroupId) {\n        __typename\n        ...SsoAdminPortalButton_billingGroup\n      }\n    }\n    id\n  }\n}\n\nfragment SsoAdminPortalButton_billingGroup on BillingGroupErrorable {\n  __isBillingGroupErrorable: __typename\n  ... on BillingGroup {\n    id\n    type\n    ssoAdminPortalLink {\n      __typename\n      ... on SsoAdminPortalLink {\n        link\n      }\n      ... on GraphEntityError {\n        message\n        statusCode\n      }\n    }\n  }\n  ... on GraphEntityError {\n    message\n    statusCode\n  }\n}\n\nfragment SsoAdminPortalButton_org on Org {\n  id\n}\n"
        }
    } as any;
})();
(node as any).hash = '787aca994f3d6977165f32f83814932b';
export default node;
